export enum Page {
  settings,
  rfqs,
  organizations,
  rfq,
  part,
  quote,
  send,
  done,
  profile,
  help,
}
